/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Error_NoteInputs */

const da_common_error_note = /** @type {(inputs: Common_Error_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det, du allerede har gemt eller godkendt, er ikke berørt. Ændringer, du ikke nåede at gemme, kan mangle.`)
};

/** @type {(inputs: Common_Error_NoteInputs) => LocalizedString} */
const en_common_error_note = da_common_error_note;

/**

* @param {Common_Error_NoteInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const common_error_note = /** @type {((inputs?: Common_Error_NoteInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Error_NoteInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_error_note(inputs)
	return /** @type {LocalizedString} */ ("Det, du allerede har gemt eller godkendt, er ikke berørt. Ændringer, du ikke nåede at gemme, kan mangle.")
});